require('../Placeholder.scss');
require('./Placeholder_ProgramSnippet.scss');
require('../../ProgramSnippet/ProgramSnippet.scss');

const b = require('app/www/libs/b')('program-snippet-placeholder');
const bPlaceholder = require('app/www/libs/b')('placeholder', true);

const React = require('react');
const PropTypes = require('prop-types');

const Placeholder_ProgramSnippet = (props) => {
    const {hidden} = props;

    return (
        <div className={bPlaceholder.mix(b(), {hidden})}>
            <div className={`${b('image')} ${bPlaceholder('rectangle')}`} />
            <div className={b('info')}>
                <div className={`${b('meta')} ${bPlaceholder('line')}`} />
                <div className={`${b('title')} ${bPlaceholder('line')}`} />
                <div className={`${b('event')} ${bPlaceholder('line')}`} />
            </div>
        </div>
    );
};

Placeholder_ProgramSnippet.propTypes = {
    hidden: PropTypes.bool,
};

module.exports = Placeholder_ProgramSnippet;
